export default __webpack_public_path__ + "assets/pdf/FT_Turbina.20c3712d.pdf";